import type { SVGProps } from 'react'

interface WeatherSatelliteIconProps extends SVGProps<SVGSVGElement> {}

export function WeatherSatelliteIcon(props: WeatherSatelliteIconProps) {
  return (
    <svg
      width={75}
      height={52}
      viewBox="0 0 75 52"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M48.498 22.975l-5.336 3.082-.454-5.03 5.79-2.895v4.843z"
        fill="currentColor"
      />
      <path
        d="M41.227 20.713l1.935.494 5.337-3.075-4.196-2.429-5.337 3.082 2.261 1.928z"
        fill="currentColor"
      />
      <path
        d="M43.162 26.057l-4.196-2.428v-4.844l4.196 2.422v4.85zM74.37 33.255l-1.355.78-.227-.86 1.581-.694v.773z"
        fill="currentColor"
      />
      <path
        d="M73.014 33.268l1.355-.787L18.099 0l-1.354.78 56.27 32.488z"
        fill="currentColor"
      />
      <path
        d="M73.014 34.035L16.745 1.555V.78l56.27 32.487v.767zM4.724 11.327l.374-.58-3.763-2.168-.347.2.014.294 3.722 2.254zM5.11 11.414l.414.087v4.97l-.346.2-.247-.42-.154-4.837h.334z"
        fill="currentColor"
      />
      <path
        d="M5.098 10.747l-.347.2-.054.58.48.167.347-.193-.426-.754z"
        fill="currentColor"
      />
      <path
        d="M4.75 16.924l.428-.253v-4.977l-.427-.747L.988 8.78l-.433.247v4.976l.433.747 3.763 2.175zM9.614 14.156l.373-.58L6.225 11.4l-.347.2.02.293 3.716 2.262zM10.007 14.242l.414.08V19.3l-.347.2-.253-.42-.147-4.837h.333z"
        fill="currentColor"
      />
      <path
        d="M9.987 13.575l-.347.2-.046.574.48.174.347-.2-.434-.748z"
        fill="currentColor"
      />
      <path
        d="M9.64 19.746l.434-.247v-4.976l-.433-.747L5.878 11.6l-.427.253v4.977l.427.747 3.763 2.168zM14.51 16.978l.374-.574-3.763-2.175-.347.2.014.294 3.722 2.255zM14.897 17.064l.42.087v4.977l-.353.2-.247-.427-.147-4.837h.327z"
        fill="currentColor"
      />
      <path
        d="M14.884 16.404l-.347.2-.047.574.474.166.353-.193-.433-.747z"
        fill="currentColor"
      />
      <path
        d="M14.537 22.575l.427-.247v-4.983l-.427-.74-3.763-2.176-.433.247v4.977l.433.747 3.763 2.175zM19.4 19.806l.373-.58-3.762-2.168-.347.193.02.294 3.716 2.261zM19.794 19.893l.413.08v4.976l-.347.2-.253-.42-.147-4.836h.334z"
        fill="currentColor"
      />
      <path
        d="M19.773 19.226l-.34.2-.053.573.48.174.347-.2-.434-.747z"
        fill="currentColor"
      />
      <path
        d="M19.433 25.396l.427-.246v-4.977l-.427-.747-3.769-2.175-.427.254v4.976l.427.747 3.77 2.168zM24.296 22.628l.374-.574-3.763-2.175-.346.2.02.294 3.715 2.255zM24.69 22.715l.414.086v4.977l-.347.193-.254-.42-.147-4.836h.334z"
        fill="currentColor"
      />
      <path
        d="M24.67 22.054l-.347.2-.047.574.48.167.348-.194-.434-.747z"
        fill="currentColor"
      />
      <path
        d="M24.323 28.225l.434-.254v-4.976l-.434-.74-3.762-2.175-.434.246v4.977l.434.747 3.762 2.175zM4.724 5.097l.374-.58-3.763-2.175-.347.2.014.293 3.722 2.262zM5.11 5.183l.414.08v4.977l-.346.2-.247-.42-.154-4.837h.334z"
        fill="currentColor"
      />
      <path
        d="M5.098 4.516l-.347.2-.054.574.48.174.347-.2-.426-.748z"
        fill="currentColor"
      />
      <path
        d="M4.75 10.694l.428-.254V5.464l-.427-.748L.988 2.542l-.433.253v4.977l.433.747 3.763 2.175zM9.614 7.919l.373-.574L6.225 5.17l-.347.2.02.294 3.716 2.255zM10.007 8.005l.414.087v4.977l-.347.2-.253-.427-.147-4.837h.333z"
        fill="currentColor"
      />
      <path
        d="M9.987 7.345l-.347.2-.046.574.48.167.347-.194-.434-.747z"
        fill="currentColor"
      />
      <path
        d="M9.64 13.516l.434-.247V8.286l-.433-.74L5.878 5.37l-.427.247v4.977l.427.747 3.763 2.175zM14.51 10.747l.374-.58-3.763-2.168-.347.193.014.3 3.722 2.255zM14.897 10.834l.42.08v4.976l-.353.2-.247-.42-.147-4.836h.327z"
        fill="currentColor"
      />
      <path
        d="M14.884 10.166l-.347.2-.047.581.474.167.353-.2-.433-.748z"
        fill="currentColor"
      />
      <path
        d="M14.537 16.337l.427-.247v-4.976l-.427-.747-3.763-2.175-.433.254v4.976l.433.747 3.763 2.168zM19.4 13.569l.373-.574-3.762-2.175-.347.2.02.294 3.716 2.255zM19.794 13.655l.413.087v4.977l-.347.2-.253-.427-.147-4.837h.334z"
        fill="currentColor"
      />
      <path
        d="M19.773 12.995l-.34.2-.053.574.48.167.347-.194-.434-.747z"
        fill="currentColor"
      />
      <path
        d="M19.433 19.166l.427-.247v-4.983l-.427-.74-3.769-2.175-.427.246v4.977l.427.747 3.77 2.175zM24.296 16.397l.374-.58-3.763-2.168-.346.193.02.3 3.715 2.255zM24.69 16.484l.414.08v4.977l-.347.2-.254-.42-.147-4.837h.334z"
        fill="currentColor"
      />
      <path
        d="M24.67 15.817l-.347.2-.047.58.48.167.348-.2-.434-.747z"
        fill="currentColor"
      />
      <path
        d="M24.323 21.994l.434-.253v-4.977l-.434-.747-3.762-2.175-.434.254v4.976l.434.747 3.762 2.175z"
        fill="currentColor"
      />
      <path
        d="M25.104 25.65l-.347.2 1.654-.027.687.214.347-.207v-1.988l.96.82.348-.2v-.593l-1.308-.754v-2.128l-2.341-3.122-.347.2.233.654 1.875 2.415.067 4.195-1.828.32z"
        fill="currentColor"
      />
      <path
        d="M24.757 25.85v.6l2.341-.413v-2.128l1.308.754v-.6l-1.308-.748v-2.128l-2.341-3.122v.594l1.828 2.435v4.436l-1.828.32zM30.574 30.153l.14 4.516 1.074 1 13.302-7.678v-4.623l-14.516 6.785z"
        fill="currentColor"
      />
      <path
        d="M29.693 24.69l12.561-6.232 2.835 4.91-13.302 7.679-3.855-4.91 1.76-1.448z"
        fill="currentColor"
      />
      <path
        d="M42.848 21.078l-5.685 3.282 1.21 2.097 5.686-3.282-1.211-2.098zM37.467 25.94l-2.127 1.226.453.786 2.127-1.226-.453-.786zM38.252 16.15L24.95 23.83l.64 2.254 3.37.054 13.295-7.678-4.003-2.309z"
        fill="currentColor"
      />
      <path
        d="M28.96 26.137l-4.01-2.308-2.835 1.634v4.623l2.835 4.91 4.003 2.315 2.835-1.642v-4.622l-2.828-4.91zM20.467 25.836l-.407-.507-.473-.267-.407.034-.234.333v.54l.234.608.407.507.473.273.407-.04.234-.333v-.54l-.234-.608z"
        fill="currentColor"
      />
      <path
        d="M20.06 25.876l.408-.04.233.608.013.873-.607-1.02-.046-.42z"
        fill="currentColor"
      />
      <path
        d="M19.307 24.883l.754.447.406.507-.266.153-.808-.627-.086-.48zM18.04 24.736l.24-.447-.895.08-.407.233.254.2.807-.066zM19.794 29.472l.407-.233.514-.727-.514.06-.407.9z"
        fill="currentColor"
      />
      <path
        d="M20.594 27.297l.12.02v1.195l-.407.233-.093-1.24.38-.208z"
        fill="currentColor"
      />
      <path
        d="M19.98 25.99h.22l.515 1.328-.407.233-.594-1.327.267-.234z"
        fill="currentColor"
      />
      <path
        d="M18.987 24.916l.32-.033.894 1.107-.407.233-1.034-1.107.227-.2z"
        fill="currentColor"
      />
      <path
        d="M17.872 24.522l.407-.233 1.027.593-.407.234-.8-.073-.227-.52z"
        fill="currentColor"
      />
      <path
        d="M19.794 26.223l-.894-1.107-1.028-.594-.893.08-.514.727v1.194l.514 1.328.893 1.107 1.028.594.894-.08.513-.727V27.55l-.513-1.328zM20.34 30.693l-.226-.28-.26-.147-.22.02-.134.18v.3l.133.334.22.28.26.147.227-.013.127-.187v-.3l-.127-.334z"
        fill="currentColor"
      />
      <path
        d="M20.114 30.713l.227-.02.127.334.006.487-.333-.567-.027-.234z"
        fill="currentColor"
      />
      <path
        d="M19.7 30.166l.414.247.227.28-.147.087-.447-.347-.047-.267zM19 30.086l.134-.247-.494.04-.22.134.133.113.447-.04zM19.967 32.694l.227-.127.28-.4-.28.034-.227.493z"
        fill="currentColor"
      />
      <path
        d="M20.407 31.5l.067.013v.654l-.22.127-.054-.68.207-.114z"
        fill="currentColor"
      />
      <path
        d="M20.067 30.773l.127.007.28.733-.22.127-.327-.734.14-.133z"
        fill="currentColor"
      />
      <path
        d="M19.52 30.186l.18-.02.494.614-.227.127-.567-.614.12-.107z"
        fill="currentColor"
      />
      <path
        d="M18.906 29.966l.227-.127.567.327-.227.127-.44-.04-.127-.287z"
        fill="currentColor"
      />
      <path
        d="M19.967 30.906l-.493-.613-.567-.327-.487.046-.287.4v.661l.287.727.487.614.567.327.493-.047.287-.4v-.654l-.287-.734zM31.18 38.278l-2.282 1.32-.954-10.54 3.236-.933v10.153z"
        fill="currentColor"
      />
      <path
        d="M24.843 28.398l4.056 1.04 2.281-1.313-8.792-5.077-2.282 1.32 4.737 4.03z"
        fill="currentColor"
      />
      <path
        d="M28.899 39.599l-8.793-5.084V24.37l8.793 5.07v10.16z"
        fill="currentColor"
      />
      <path
        d="M27.952 35.03l-.654-.808-.747-.44-.654.06-.374.534v.867l.374.974.654.807.747.433.654-.06.373-.533v-.867l-.373-.968z"
        fill="currentColor"
      />
      <path
        d="M27.298 35.096l.654-.067.373.968.02 1.4-.974-1.64-.073-.661z"
        fill="currentColor"
      />
      <path
        d="M26.098 33.502l1.2.72.654.807-.427.247-1.294-1-.133-.775zM24.07 33.261l.38-.713-1.428.126-.647.374.4.327 1.294-.114zM26.878 40.846l.647-.373.82-1.174-.82.1-.647 1.447z"
        fill="currentColor"
      />
      <path
        d="M28.152 37.364l.193.033V39.3l-.647.373-.153-1.981.607-.327z"
        fill="currentColor"
      />
      <path
        d="M27.172 35.27l.354.006.82 2.121-.647.374-.954-2.121.427-.38z"
        fill="currentColor"
      />
      <path
        d="M25.584 33.562l.514-.06 1.427 1.774-.647.373-1.654-1.774.36-.313z"
        fill="currentColor"
      />
      <path
        d="M23.803 32.921l.647-.373 1.648.954-.647.373-1.288-.12-.36-.834z"
        fill="currentColor"
      />
      <path
        d="M26.878 35.65l-1.427-1.775-1.648-.954-1.428.127-.82 1.174v1.901l.82 2.122 1.428 1.774 1.648.954 1.427-.127.82-1.174v-1.901l-.82-2.121z"
        fill="currentColor"
      />
      <path
        d="M26.565 35.83l-1.04-1.301-1.201-.694-1.048.094-.6.853v1.395l.6 1.547 1.047 1.295 1.201.7 1.04-.093.601-.861v-1.388l-.6-1.547z"
        fill="currentColor"
      />
      <path
        d="M26.278 35.996l-.654-.813-.747-.434-.654.06-.373.534v.867l.373.967.654.814.747.434.654-.06.373-.534v-.867l-.373-.968z"
        fill="currentColor"
      />
      <path
        d="M25.43 36.19l-.36-.207-.254.147v.413l.254.44.36.208.254-.147v-.414l-.254-.44z"
        fill="currentColor"
      />
      <path
        d="M22.702 38.098l.007.114.026.02 2.629-1.515v-.113l-2.662 1.494z"
        fill="currentColor"
      />
      <path
        d="M22.682 37.971l2.615-1.487.066.12-2.628 1.52-.093-.12.04-.033z"
        fill="currentColor"
      />
      <path
        d="M25.203 36.43l-2.635 1.521.014.053h.086l2.629-1.52-.094-.054z"
        fill="currentColor"
      />
      <path
        d="M22.669 38.005l-.1-.054-.067.033v.114l.067.12.1.053.066-.04v-.106l-.066-.12z"
        fill="currentColor"
      />
      <path
        d="M22.542 38.278l.013.34.08.08.2-.113v-.354l-.293.047z"
        fill="currentColor"
      />
      <path
        d="M22.482 37.858h.14l.213.373-.2.114-.293-.374.14-.113z"
        fill="currentColor"
      />
      <path
        d="M22.315 37.684l-.194.114.047.166.253.007.2-.113-.306-.174z"
        fill="currentColor"
      />
      <path
        d="M22.422 37.971l-.3-.173-.22.12v.354l.22.373.3.173.213-.12v-.353l-.213-.374zM27.912 30.313l-.407-.507-.474-.267-.407.033-.233.334v.547l.233.6.407.507.474.274.407-.034.233-.34v-.54l-.233-.607z"
        fill="currentColor"
      />
      <path
        d="M27.505 30.353l.407-.04.233.607.014.874-.607-1.021-.047-.42z"
        fill="currentColor"
      />
      <path
        d="M26.751 29.359l.754.447.407.507-.267.153-.807-.62-.087-.487zM25.483 29.212l.234-.447-.887.08-.407.234.253.2.808-.067zM27.238 33.955l.407-.233.514-.734-.514.06-.407.907z"
        fill="currentColor"
      />
      <path
        d="M28.038 31.774l.12.02v1.194l-.406.233-.094-1.24.38-.207z"
        fill="currentColor"
      />
      <path
        d="M27.425 30.466h.22l.514 1.328-.407.233-.594-1.327.267-.234z"
        fill="currentColor"
      />
      <path
        d="M26.43 29.399l.321-.04.894 1.107-.407.234-1.034-1.108.227-.193z"
        fill="currentColor"
      />
      <path
        d="M25.316 28.999l.4-.234 1.035.594-.407.233-.8-.073-.228-.52z"
        fill="currentColor"
      />
      <path
        d="M27.238 30.7l-.894-1.108L25.317 29l-.894.08-.514.727V31l.514 1.327.894 1.108 1.027.6.894-.08.514-.734v-1.194l-.514-1.327zM13.155 34.736l.014.353.08.074 8.432-4.864v-.36l-8.526 4.797z"
        fill="currentColor"
      />
      <path
        d="M13.09 34.316l8.371-4.757.22.38-8.432 4.87-.3-.38.14-.114z"
        fill="currentColor"
      />
      <path
        d="M21.147 29.379l-8.425 4.87.046.173.26.007 8.433-4.87-.314-.18z"
        fill="currentColor"
      />
      <path
        d="M13.029 34.429l-.307-.18-.22.127v.36l.22.38.307.18.22-.133v-.354l-.22-.38z"
        fill="currentColor"
      />
      <path
        d="M12.648 35.303l.034 1.094.26.246.627-.367v-1.12l-.92.147z"
        fill="currentColor"
      />
      <path
        d="M12.436 33.975l.447-.013.687 1.194-.627.36-.941-1.194.434-.347z"
        fill="currentColor"
      />
      <path
        d="M11.908 33.401l-.627.36.154.548.82.013.627-.36-.974-.56z"
        fill="currentColor"
      />
      <path
        d="M12.256 34.322l-.974-.56-.694.4v1.12l.694 1.195.974.567.687-.4v-1.128l-.687-1.194zM22.936 31.494l.014.413.1.094.233-.14v-.42l-.347.053z"
        fill="currentColor"
      />
      <path
        d="M22.855 30.993h.167l.26.447-.233.134-.354-.447.16-.134z"
        fill="currentColor"
      />
      <path
        d="M22.656 30.78l-.233.14.06.2.307.007.233-.134-.367-.213z"
        fill="currentColor"
      />
      <path
        d="M22.79 31.127l-.368-.207-.26.147v.42l.26.447.367.213.26-.146v-.427l-.26-.447z"
        fill="currentColor"
      />
      <path
        d="M19.56 33.341l.007.134.034.026 3.162-1.827v-.134l-3.203 1.801z"
        fill="currentColor"
      />
      <path
        d="M19.54 33.181l3.143-1.78.08.14-3.162 1.827-.114-.14.054-.047z"
        fill="currentColor"
      />
      <path
        d="M22.57 31.334L19.4 33.16l.02.06.094.007 3.169-1.828-.114-.066z"
        fill="currentColor"
      />
      <path
        d="M19.514 33.228l-.114-.067-.08.047v.134l.08.14.114.066.087-.046v-.134l-.087-.14zM17.887 34.409l.013.414.1.093 1.721-.994v-.427l-1.834.914z"
        fill="currentColor"
      />
      <path
        d="M17.806 33.909l1.654-.86.26.446-1.72 1-.355-.453.16-.133z"
        fill="currentColor"
      />
      <path
        d="M19.093 32.841l-1.72.994.06.207h.306l1.721-.994-.367-.207z"
        fill="currentColor"
      />
      <path
        d="M17.74 34.042l-.367-.207-.26.147v.42l.26.454.366.207.26-.147v-.42l-.26-.454z"
        fill="currentColor"
      />
      <path
        d="M18.006 34.202l-.267-.34-.32-.187-.273.027-.154.227v.36l.154.407.273.34.32.18.267-.02.16-.227v-.36l-.16-.407z"
        fill="currentColor"
      />
      <path
        d="M17.74 34.229l.266-.027.16.407.014.587-.414-.694-.027-.273z"
        fill="currentColor"
      />
      <path
        d="M17.232 33.555l.507.307.267.34-.173.1-.547-.42-.054-.327zM16.378 33.462l.16-.3-.6.053-.267.153.167.134.54-.04zM17.559 36.644l.273-.16.347-.494-.347.046-.273.608z"
        fill="currentColor"
      />
      <path
        d="M18.093 35.176l.087.02v.794l-.273.16-.067-.834.253-.14z"
        fill="currentColor"
      />
      <path
        d="M17.686 34.302h.147l.347.894-.274.153-.4-.887.18-.16z"
        fill="currentColor"
      />
      <path
        d="M17.019 33.582l.213-.027.6.747-.273.16-.694-.747.154-.133z"
        fill="currentColor"
      />
      <path
        d="M16.271 33.315l.267-.154.694.394-.273.16-.54-.047-.148-.353z"
        fill="currentColor"
      />
      <path
        d="M17.559 34.462l-.6-.747-.688-.4-.6.053-.347.494v.8l.347.888.6.747.688.4.6-.053.347-.494v-.8l-.347-.888zM21.613 26.71l.027.708.167.16.407-.234v-.733l-.6.1z"
        fill="currentColor"
      />
      <path
        d="M21.48 25.843l.293-.006.44.773-.407.24-.607-.773.28-.234z"
        fill="currentColor"
      />
      <path
        d="M21.14 25.47l-.413.24.1.353.533.014.414-.24-.634-.367z"
        fill="currentColor"
      />
      <path
        d="M21.36 26.077l-.634-.367-.447.253v.734l.447.774.634.367.447-.26v-.727l-.447-.774z"
        fill="currentColor"
      />
      <path
        d="M15.783 29.906l.007.227.053.047 5.477-3.162v-.234l-5.537 3.122z"
        fill="currentColor"
      />
      <path
        d="M15.737 29.626l5.444-3.089.14.247-5.477 3.162-.194-.247.087-.073z"
        fill="currentColor"
      />
      <path
        d="M20.973 26.424l-5.47 3.162.027.113h.173l5.477-3.162-.207-.113z"
        fill="currentColor"
      />
      <path
        d="M15.703 29.7l-.2-.114-.147.08v.233l.147.247.2.12.14-.086v-.234l-.14-.247zM12.882 31.754l.02.714.173.153 2.982-1.714v-.734l-3.175 1.58z"
        fill="currentColor"
      />
      <path
        d="M12.742 30.887l2.869-1.488.447.774-2.982 1.721-.607-.774.273-.233z"
        fill="currentColor"
      />
      <path
        d="M14.977 29.032l-2.982 1.721.1.354.534.013 2.982-1.72-.634-.368z"
        fill="currentColor"
      />
      <path
        d="M12.629 31.12l-.634-.367-.447.26v.728l.447.773.634.367.447-.26v-.727l-.447-.774zM26.805 35.283l.013.407.1.086 1.701-.98v-.42l-1.814.907z"
        fill="currentColor"
      />
      <path
        d="M26.724 34.79l1.64-.855.254.44-1.701.988-.354-.447.16-.127z"
        fill="currentColor"
      />
      <path
        d="M27.998 33.722l-1.701.987.06.2.3.007 1.708-.98-.367-.214z"
        fill="currentColor"
      />
      <path
        d="M26.658 34.916l-.36-.207-.254.147v.42l.253.44.36.207.26-.147v-.413l-.26-.447zM32.995 20.893l.007.394.34.2.093-.153.007-.307-.447-.134z"
        fill="currentColor"
      />
      <path
        d="M33.916 21.24l-.06.247h-.513V21.1l.113-.087.4.02.06.207z"
        fill="currentColor"
      />
      <path
        d="M34.209 20.893v.394l-.354.2V21.1l.174-.307.18.1z"
        fill="currentColor"
      />
      <path
        d="M33.856 21.1l.353-.207v-.287l-.353-.206h-.514l-.347.207v.286l.347.207h.514z"
        fill="currentColor"
      />
      <path
        d="M33.195 18.185v2.662l.24.133.06-.1v-2.608l-.3-.087zM34.017 18.185v2.662l-.247.133-.154-2.915.154.253.086-.133h.16z"
        fill="currentColor"
      />
      <path
        d="M33.77 20.98h-.335v-2.662l.06-.06.274.02v2.702z"
        fill="currentColor"
      />
      <path
        d="M33.769 17.845h-.334l-.24.146v.194l.24.133h.334l.247-.133v-.194l-.247-.146z"
        fill="currentColor"
      />
      <path
        d="M33.309 15.31v2.822l.173.1.04-.074V15.37l-.213-.06z"
        fill="currentColor"
      />
      <path
        d="M33.756 18.105l-.033.127h-.24V15.41l.046-.04.194.006.033 2.729z"
        fill="currentColor"
      />
      <path
        d="M33.896 15.31v2.821l-.173.1V15.41l.08-.154.093.054z"
        fill="currentColor"
      />
      <path
        d="M33.722 15.07h-.24l-.173.106v.134l.173.1h.24l.174-.1v-.134l-.174-.106z"
        fill="currentColor"
      />
      <path
        d="M34.03 14.67l.193-.027v.48l-2.155 1.24-.087-.253.047-.273 2.001-1.168z"
        fill="currentColor"
      />
      <path
        d="M31.661 15.643l2.155-1.247.407.247-2.155 1.247-.087.007-.32-.254z"
        fill="currentColor"
      />
      <path
        d="M31.661 16.124l.407.24v-.474l-.407-.247v.48z"
        fill="currentColor"
      />
      <path
        d="M32.581 15.77l-.406-.507-.474-.273-.4.04-.24.333v.54l.24.608.4.507.474.273.407-.04.233-.333v-.54l-.233-.608z"
        fill="currentColor"
      />
      <path
        d="M32.175 15.81l.407-.04.233.607.014.874-.608-1.027-.046-.414z"
        fill="currentColor"
      />
      <path
        d="M31.42 14.816l.755.447.407.507-.267.154-.807-.627-.087-.48zM30.154 14.67l.24-.448-.894.08-.407.234.253.2.808-.067zM31.908 19.406l.407-.234.514-.727-.514.06-.407.9z"
        fill="currentColor"
      />
      <path
        d="M32.708 17.231l.12.02v1.194l-.4.234-.1-1.241.38-.207z"
        fill="currentColor"
      />
      <path
        d="M32.095 15.924h.22l.514 1.327-.4.234-.6-1.328.266-.233z"
        fill="currentColor"
      />
      <path
        d="M31.1 14.85l.321-.034.894 1.107-.407.234-1.034-1.107.227-.2z"
        fill="currentColor"
      />
      <path
        d="M29.986 14.456l.407-.234 1.028.594-.4.234-.808-.074-.227-.52z"
        fill="currentColor"
      />
      <path
        d="M31.908 16.157l-.887-1.107-1.034-.594-.894.08-.514.727v1.194l.514 1.328.894 1.107 1.034.594.887-.08.52-.727v-1.195l-.52-1.327zM42.075 28.258v-.594l-2.348.414-.34.2.34.327v1.6l-1.301-.753-.347.2.347.607 1.3.754v2.275l1.669 2.235.333.727.347-.2v-.594l-1.828-2.442v-4.43l1.828-.326z"
        fill="currentColor"
      />
      <path
        d="M41.728 28.458v-.593l-2.341.413V30.4l-1.308-.748v.594l1.308.754v2.121l2.341 3.129v-.6L39.9 33.215v-4.43l1.828-.327zM45.898 35.102l.373-.58-3.762-2.175-.347.2.02.3 3.716 2.255zM46.285 35.19l.414.08v4.976l-.34.2-.254-.42-.147-4.837h.327z"
        fill="currentColor"
      />
      <path
        d="M46.272 34.522l-.347.2-.047.574.48.173.34-.2-.426-.747z"
        fill="currentColor"
      />
      <path
        d="M45.925 40.693l.433-.247v-4.977l-.433-.747-3.763-2.174-.434.253v4.977l.434.747 3.763 2.168zM50.788 37.924l.373-.574-3.762-2.174-.34.2.013.293 3.716 2.255zM51.181 38.011l.414.087v4.976l-.347.2-.254-.427-.146-4.836h.333z"
        fill="currentColor"
      />
      <path
        d="M51.161 37.35l-.347.2-.046.574.48.174.347-.2-.434-.747z"
        fill="currentColor"
      />
      <path
        d="M50.814 43.521l.434-.247v-4.976l-.434-.748-3.755-2.174-.434.247v4.976l.434.747 3.755 2.175zM55.684 40.753l.373-.58-3.762-2.175-.347.2.02.3 3.716 2.255zM56.078 40.84l.413.08v4.976l-.347.2-.253-.42-.147-4.837h.334z"
        fill="currentColor"
      />
      <path
        d="M56.058 40.172l-.347.2-.047.574.48.174.347-.2-.433-.748z"
        fill="currentColor"
      />
      <path
        d="M55.71 46.343l.434-.247V41.12l-.433-.747-3.763-2.175-.433.253v4.977l.433.747 3.763 2.168zM60.58 43.575l.374-.574-3.77-2.175-.34.2.014.294 3.723 2.255zM60.967 43.661l.414.087v4.977l-.347.2-.247-.427-.153-4.837h.333z"
        fill="currentColor"
      />
      <path
        d="M60.954 43.001l-.347.2-.053.574.48.167.347-.194-.427-.747z"
        fill="currentColor"
      />
      <path
        d="M60.607 49.172l.427-.247v-4.983l-.427-.74-3.762-2.176-.434.247v4.977l.434.747 3.762 2.175zM65.47 46.403l.374-.58-3.763-2.169-.347.194.02.294 3.716 2.261zM65.864 46.49l.413.08v4.976l-.347.2-.253-.42-.147-4.837h.334z"
        fill="currentColor"
      />
      <path
        d="M65.844 45.822l-.347.2-.047.581.48.167.347-.2-.433-.748z"
        fill="currentColor"
      />
      <path
        d="M65.497 52l.434-.254V46.77l-.434-.747-3.762-2.175-.427.253v4.977l.427.747L65.497 52zM45.898 28.865l.373-.574-3.762-2.174-.347.2.02.293 3.716 2.255zM46.285 28.959l.414.08v4.976l-.34.2-.254-.427-.147-4.83h.327z"
        fill="currentColor"
      />
      <path
        d="M46.272 28.291l-.347.2-.047.574.48.174.34-.2-.426-.748z"
        fill="currentColor"
      />
      <path
        d="M45.925 34.462l.433-.247V29.24l-.433-.747-3.763-2.175-.434.247v4.976l.434.747 3.763 2.175zM50.788 31.694l.373-.58-3.762-2.169-.34.194.013.3 3.716 2.255zM51.181 31.78l.414.08v4.977l-.347.2-.254-.42-.146-4.837h.333z"
        fill="currentColor"
      />
      <path
        d="M51.161 31.113l-.347.2-.046.58.48.167.347-.2-.434-.747z"
        fill="currentColor"
      />
      <path
        d="M50.814 37.29l.434-.253V32.06l-.434-.747-3.755-2.175-.434.254v4.976l.434.748 3.755 2.174zM55.684 34.516l.373-.574-3.762-2.175-.347.2.02.294 3.716 2.255zM56.078 34.609l.413.08v4.977l-.347.2-.253-.427-.147-4.83h.334z"
        fill="currentColor"
      />
      <path
        d="M56.058 33.942l-.347.2-.047.574.48.173.347-.2-.433-.747z"
        fill="currentColor"
      />
      <path
        d="M55.71 40.112l.434-.246v-4.977l-.433-.747-3.763-2.175-.433.247v4.977l.433.747 3.763 2.174zM60.58 37.344l.374-.58-3.77-2.169-.34.2.014.294 3.723 2.255zM60.967 37.43l.414.08v4.977l-.347.2-.247-.42-.153-4.836h.333z"
        fill="currentColor"
      />
      <path
        d="M60.954 36.763l-.347.2-.053.58.48.168.347-.2-.427-.748z"
        fill="currentColor"
      />
      <path
        d="M60.607 42.934l.427-.247v-4.976l-.427-.747-3.762-2.168-.434.246v4.977l.434.747 3.762 2.168zM65.47 40.166l.374-.574-3.763-2.175-.347.2.02.294 3.716 2.255zM65.864 40.252l.413.087v4.977l-.347.2-.253-.427-.147-4.837h.334z"
        fill="currentColor"
      />
      <path
        d="M65.844 39.592l-.347.2-.047.574.48.173.347-.2-.433-.747z"
        fill="currentColor"
      />
      <path
        d="M65.497 45.763l.434-.247v-4.977l-.434-.747-3.762-2.175-.427.247v4.977l.427.747 3.762 2.175z"
        fill="currentColor"
      />
    </svg>
  )
}
